





































import { Component, Vue, Watch } from 'vue-property-decorator';
import Logo from '@/components/logo.vue';
import Dashboard from '@/components/materiel/Dashboard.vue';
import TopToolbar from '@/components/TopToolbar.vue';
import Loading from '@/util/loading';
import Setting from '@/components/setting/index.vue';
import { AppModule } from '@/store/modules/app';
import { SettingModule } from '@/store/modules/setting';
import CompBox from '@/components/materiel/CompBox/index.vue';
import JsonEditor from '@/components/JsonEditor/index.vue';
import WorkerIframe from '@/components/WorkerIframe/index.vue';
import _ from 'lodash';
import Message from '@/util/MessageWorker';
@Component({
  components: {
    Logo,
    Dashboard,
    TopToolbar,
    Setting,
    CompBox,
    JsonEditor,
    WorkerIframe,
  }
})
export default class App extends Vue {
  private dashboardTabIndex = '0';
  private settingData = null;
  private settingWidth = '80px';
  private formIndex = 0;
  private isCompPast = true;

  get showDashboard() {
    return AppModule.showDashboard;
  }

  get showComponentBox() {
    return AppModule.showComponentBox;
  }

  get boxUuid() {
    return AppModule.boxUuid;
  }

  async created() {
    // await socket.emit('home.index.init');

    // window.onunload = async e => {
    //   await socket.emit('generator.scene.refresh');
    // };

    Message.on('client.dispatch.component', (data) => {
       setTimeout(() => {
        if (data.uuid !== undefined) {
          AppModule.setBoxUuid(data.uuid);
        }
      }, 200);
    })

    Message.on('client.dispatch.box', (data) => {
      setTimeout(() => {
        if (data.uuid !== undefined) {
          AppModule.setBoxUuid(data.uuid);
        }
      }, 200);
    })


    window.addEventListener('message', async event => {
      const { data } = event;
      if (!data.handler) return;
      console.log(data);
      const handlerArr = data.handler.split('.');
      const handlerFirst = handlerArr[0];
      if (handlerFirst === 'client') {
        // 插入组件label
        if (data.handler === 'client.component.insertLabel') {
          const params = {
            data: {
              ...data.data.params,
            }
          };
          const result = await Message.emit('generator.scene.insertLabel', params);
        }

        // 同步编辑文本文案
        if (data.handler === 'client.component.insertEditText') {
          const { params } = data.data;
          await Message.emit('generator.scene.insertEditText', params);
        }

        if (data.handler === 'client.screen.keydown') {
          const {operate} = data;
          if (operate === 'ctrl+c') {
            this.isCompPast = true;
            this.copyHandler();
          } else if (operate === 'ctrl+v') {
            setTimeout(() => {
              if (this.isCompPast) {
                this.pasteHandler();
              }
            }, 500);
          } else if (operate === 'delete') {
            this.deleteComp();
          }

        }

        if (data.handler === 'client.component.paste') {
          this.isCompPast = false;
        }

        // 延迟同步uuid
        setTimeout(() => {
          if (data.uuid !== undefined) {
            AppModule.setBoxUuid(data.uuid);
          }
        }, 200);
      }
    });

    // block 进度
    Message.on('generator.scene.block.status', data => {
      Loading.close();
    });

    Message.on('generator.plugin.status', data => {
      Loading.close();
    });

    Message.on('generator.force.refresh',data => {
      const viewContent:any = document.querySelector('#viewContent')
      setTimeout(() => {
        viewContent.contentWindow.location.reload(true)
      }, 500)
    });

   

    // generate-file

    this.settingData = {};
  }

  mounted() {
    const viewContent: any = this.$refs.viewContent;
    viewContent.addEventListener('click', e => {
      e.stopPropagation();
    });
    // Message.emit('sparrow-test', {id: 1});
  }

  private async pasteHandler () {
    // pasteHandler
    const result = await Message.emit('generator.scene.pasteHandler', {
      compId: this.boxUuid,
    });
  }

  private async deleteComp () {
    await Message.emit('generator.scene.deleteComponent', {
      id: AppModule.activeCompId
    });
  }

  private async copyHandler () {
    const result = await Message.emit('generator.scene.copyHandler', {
      activeCompId: AppModule.activeCompId
    });
    this.$message({
      message: '复制成功',
      type: 'success'
    });
  }

  private async selectedHandler(data) {}
}
